import * as React from "react";
import {useMemo} from "react";
import {useAppDispatch, useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";
import {setLastSeenUpdateDate} from "@/redux/product.params.slice";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FaIcon from "@/components/utilities/fa-icon";
import {useTheme} from "@mui/material/styles";
import {useProductLastUpdate} from "@/lib/api";


export default function LastUpdateBadge({initialLastUpdate}: { initialLastUpdate: number | null }) {
    const theme = useTheme()
    const dispatch = useAppDispatch()
    const lastSeenUpdateDate = useAppSelector((state: RootState) => state.productLocalParams.lastSeenUpdateDate);

    const swrOptions = useMemo(() => {
        return initialLastUpdate != null
            ? {
                fallbackData: String(initialLastUpdate),
                revalidateOnMount: false,
                revalidateOnFocus: false,
            }
            : {
                revalidateOnMount: false,
                revalidateOnFocus: false,
            };
    }, [initialLastUpdate]);

    const {data: lastUpdate} = useProductLastUpdate(swrOptions);

    const setSeen = () => {
        if (lastUpdate) dispatch(setLastSeenUpdateDate(lastUpdate));
    };

    const isOpen = !!lastUpdate && lastSeenUpdateDate !== lastUpdate;

    if (!isOpen) return null;

    return (
        <Collapse in >
            <Box
                width= "100%"
                mb={{md:0,xs:1}}
            >
                <Box
                    bgcolor={theme.palette.common.white}
                    borderRadius={2}
                    p={1.5}
                    position = "relative"
                    onClick = {setSeen}
                    sx = {{
                        cursor: "pointer",
                    }}
                >
                    <FaIcon
                        fontSize = {{md:18,xs:16}}
                        color = {theme.palette.grey[500]}
                        faIcon = 'fa-close'
                        sx = {{
                            pointerEvents: "none",
                            position: "absolute",
                            right: 10,
                            top: {md: "50%", xs: 20},
                            transform: "translate(0%,-50%)",
                        }}
                    />

                    <Box display = {{md: 'none', xs: "block"}} alignItems = 'center' >
                        <Box display = 'flex' >

                            <Box display = 'flex'
                                justifyContent = 'center'
                                alignItems = 'center'
                                color = 'primary.main'
                                mr = {1}
                            >
                                <FaIcon fontSize = {16} color = "primary.main" faIcon = 'fa-info-circle' />
                            </Box >

                            <Typography fontSize = {13} >
                                قیمت‌ها بدون 10 درصد مالیات محاسبه شده
                            </Typography >

                        </Box >
                        <Box mt = {1} display = 'flex' alignItems = 'center' >
                            <Box display = "flex" justifyContent = "center" alignItems = "center"
                                width = {16} height = {16} mr = {1} color = 'primary.main' >

                                <FaIcon fontSize = {16} sx = {{color: theme.palette.primary.main}} faIcon = "fa-clock-nine" />
                            </Box >

                            <Typography fontSize = {13} >
                                آخرین بروزرسانی اطلاعات:
                                <Typography
                                    variant = 'body2'
                                    component = 'span'
                                    display = 'inline'
                                    color={theme.palette.primary.main}
                                    fontSize={13}
                                    fontWeight={13}
                                    ml={.5}
                                >
                                    {" " + lastUpdate?.toString()}
                                </Typography >
                            </Typography >

                        </Box >
                    </Box >

                    <Box display= {{md: 'flex', xs: "none"}} alignItems = 'center' >
                        <Box
                            display = 'flex'
                            justifyContent = 'center'
                            alignItems = 'center'
                            mr = {1}
                            color = 'primary.main'
                        >
                            <FaIcon fontSize = {16} color = "primary.main" faIcon = "fa-info-circle" />
                        </Box >

                        <Typography display= 'inline-block' variant = "body2" >
                            قیمت‌ها بدون 10 درصد مالیات بر ارزش افزوده محاسبه شده
                        </Typography >
                        <Typography px = {2} variant = 'body2' >
                            |
                        </Typography >
                        <Typography display= 'inline-block' variant = 'body2' >
                            آخرین بروزرسانی موجودی و قیمت:
                        </Typography >
                        <Typography
                            ml={1}
                            fontWeight={500}
                            color={theme.palette.primary.main}
                            display = "inline-block"
                            variant = "body2"
                        >
                            <FaIcon sx = {{mt:.5, mr: 0.5, color: theme.palette.primary.main}} faIcon = "fa-clock" />
                            {" " + lastUpdate?.toString()}
                        </Typography >
                    </Box >

                </Box >
            </Box >
        </Collapse >


    )
}